export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  INVESTOR_PORTAL: '/investor-portal',
  NOT_FOUND: '*',
} as const;

export const ANCHORS = {
  PLATFORM: '#platform',
  BORROWERS: '#borrowers',
  INVESTORS: '#investors',
  TEAM: '#team',
  INTEREST: '#interest',
} as const;

/** In-page sections of the home page. Gated — these sit behind the sign-in wall. */
export const NAV_LINKS = [
  { label: 'Platform', href: ANCHORS.PLATFORM },
  { label: 'Borrowers', href: ANCHORS.BORROWERS },
  { label: 'Investors', href: ANCHORS.INVESTORS },
  { label: 'Team', href: ANCHORS.TEAM },
] as const;

/**
 * Standalone destinations. Ungated by design: a prospective investor needs to
 * reach these without an account, so they never carry the lock glyph and never
 * raise the sign-in prompt.
 */
export const NAV_ROUTE_LINKS = [
  { label: 'Investor Portal', to: ROUTES.INVESTOR_PORTAL },
] as const;

export const POLICY_SLIDER = { min: 50_000, max: 2_000_000, step: 10_000, defaultValue: 500_000 } as const;
export const INVESTMENT_SLIDER = { min: 50_000, max: 2_000_000, step: 10_000, defaultValue: 250_000 } as const;

export const RATES = {
  BANK: 0.75,
  INSURER: 0.90,
  RADIANCE_BORROW: 1.00,
  SAVINGS: 0.035,
  GIC: 0.04,
  RADIANCE_INVEST: 0.059,
  RADIANCE_INVEST2: 0.119,
} as const;

export const NAVBAR_HEIGHT = 72;

export const COMPANY = {
  NAME: 'Radiance Financial',
  TAGLINE: 'Where protected capital meets institutional return.',
  YEAR: 2026,
} as const;